import AddNote from './add-note'

import withRedux from './with-redux'

export default withRedux(AddNote)